module.exports = __webpack_public_path__ + "img/sandboxcross.622c28cd.svg";